import axiosInstance from "../../axiosInstance";

let homeDataPromise;

export const getPublicHomeData = () => {
  if (!homeDataPromise) {
    homeDataPromise = axiosInstance
      .get("/home-data")
      .then((response) => response?.data?.homeData || {})
      .catch((error) => {
        homeDataPromise = undefined;
        throw error;
      });
  }

  return homeDataPromise;
};

export const normalizePublicLink = (value) => {
  const link = String(value || "/").trim();
  if (/^(https?:)?\/\//i.test(link) || link.startsWith("mailto:") || link.startsWith("tel:")) return link;
  return link.startsWith("/") ? link : `/${link}`;
};

export const isExternalLink = (value) => /^(https?:)?\/\//i.test(String(value || ""));

export const normalizeAssetUrl = (value) => {
  if (!value) return "";
  if (/^(https?:)?\/\//i.test(String(value))) return value;
  const base = String(axiosInstance.defaults.baseURL || "").replace(/\/$/, "");
  return `${base}/${String(value).replace(/^\/+/, "")}`;
};
